export interface Survey {
  id?: number;
  title: string;
  description: string;
  confirmation: string;
  siteUrl: string;
  siteLinkText: string;
  companyName?: string;
  uniqid?: string;
  status?: SurveyStatus;
  dateAdded?: string;
  dateModified?: string;
  stepType?: "hub_and_spoke" | "customer_score";
}

/**
 * Represents the options of a radio group single question, allowing for multiple formats.For example:
 * ```typescript
 *  {"1": "Strongly disagree", "2":"Disagree", "3": "Neutral"}
 * ```
 */
export type QuestionsGroup = Record<string, string>;
/**
 * Represents the options of a radio group single question, allowing for multiple formats.For example:
 * ```typescript
 *  {"1": "Strongly disagree", "2":"Disagree", "3": "Neutral"}
 * ```
 */
export type QuestionsGroupOptions = Record<string, string>;

export type QuestionType = "radio" | "textarea" | "radiogroup" | "none";
export interface BaseQuestion {
  id: string;
  survey_id: string | null;
  minValue?: number;
  type: QuestionType;
  label: string;
  position: number;
  parent_id: number | string;
  max_value: number;
  label_min: string | null;
  label_max: string | null;
  answer: QuestionsGroup | null;
  answer_variant: QuestionsGroupOptions | null;
  is_required: boolean;
  is_displayed_editable: boolean;
  is_displayed: boolean;
  question_id?: number | string;
  step_type?: "hub_and_spoke" | "customer_score";
}

export interface Question
  extends Omit<BaseQuestion, "answer" | "answer_variant"> {
  children?: Question[];
  value?: string | Record<string, string>;
  error?: boolean;
  questionsGroup: QuestionsGroup | null;
  questionsGroupOptions: QuestionsGroupOptions | null;
}

export interface SurveyPreviewResponse {
  id: string;
  surveyData: string;
  vbSection: string;
}

export interface QuestionPreview extends BaseQuestion {
  children?: QuestionPreview[];
}
export interface SurveyPreview extends Survey {
  questions: QuestionPreview[];
}

export interface Poll {
  id: number;
  respondentTemporaryId: string;
  startedAt: string;
  status: PollStatus;
  survey: string;
}

export interface VbPollAnswer {
  value: string | Record<string, string>;
  surveyPollQuestion: string;
}

export interface RecaptchaConfig {
  reCaptchaSiteKey: string;
  error?: boolean;
  message?: string;
}

export enum SurveyStatus {
  ACTIVE = 1,
  CLOSED = 0,
}

export enum PollStatus {
  viewed = 1,
  started = 2,
  completed = 3,
  dropped = -1,
}
